<template>
  <div class="p-15px bg-[#ffffff] box-border">
    <slot></slot>
  </div>
</template>
